<template>
  <div class="qa-print__phases">
    <Card
      data-testid="qa-print-before"
      class="qa-print__phase"
      :title="$t('quick_action.phases.before')"
    >
      <template slot="content">
        <EvidenceSection
          imageTestId="before_photo"
          imageHeight="200"
          :mediaObject="before.media"
          :questions="[
            {
              text: $t('quick_action.before.whats_the_problem'),
              answer: before.situation,
              tid: 'before-problem',
            },
            {
              text: $t('quick_action.before.type_of_situation'),
              answer: before.situationTypes,
              tid: 'before-situation-type',
            },
          ]"
        />
      </template>
    </Card>
    <Card
      data-testid="qa-print-after"
      class="qa-print__phase"
      :title="$t('quick_action.phases.after')"
    >
      <template slot="content">
        <EvidenceSection
          imageTestId="after_photo"
          imageHeight="200"
          :mediaObject="after.media"
          :questions="[
            {
              text: $t('quick_action.after.what_did_you_do'),
              answer: after.solution,
              tid: 'after-solution',
            },
            {
              text: $t('quick_action.after.suggested_tags'),
              answer: after.suggestedTags,
              tid: 'after-suggested-tags',
            },
          ]"
        />
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/RevPrint/Card.vue'
import EvidenceSection from '@/components/RevPrint/EvidenceSection'
export default {
  name: 'Phases',

  components: {
    Card,
    EvidenceSection,
  },

  props: {
    after: {
      type: Object,
      required: false,
    },
    before: {
      type: Object,
      required: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.qa-print__phases {
  display: flex;
}
.qa-print__phase {
  width: 50%;
  &:first-child {
    margin-right: 20px;
  }
}
</style>
